// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageViewLayoutList_wrapper_iy-DZ","list":"PageViewLayoutList_list_20LXe","body":"PageViewLayoutList_body_3qF-I"};